import { passwordSchema } from 'shared/schemas/password.schema'
import { z } from 'zod'

export const setNewPasswordFormSchema = z
  .object({
    password: passwordSchema,
    password_confirmation: passwordSchema
  })
  .refine(data => data.password === data.password_confirmation, {
    // prettier-ignore
    message: 'Passwords don\'t match',
    path: ['password_confirmation']
  })
